import api from './api';

export type ClimaOrganizacionalRespuestaItem = {
  pregunta: number;
  valor: number; // 1..5
};

export type ClimaOrganizacionalEstadoResponse = {
  ya_realizada: boolean;
  encuesta_id: number | null;
  fecha_creacion: string | null;
  tipo_formulario?: "OP" | "ADM";
};

export type ClimaOrganizacionalPregunta = {
  pregunta: number;
  criterio: string;
  texto: string;
};

export type ClimaOrganizacionalCuestionarioResponse = {
  tipo_formulario: "OP" | "ADM";
  titulo: string;
  preguntas: ClimaOrganizacionalPregunta[];
  escala?: {
    minimo: number;
    maximo: number;
  };
};

export default {
  async enviarRespuestas(respuestas: ClimaOrganizacionalRespuestaItem[], comentario?: string) {
    return api.post('clima-organizacional/respuestas', {
      respuestas,
      comentario: comentario ?? '',
    });
  },

  async obtenerEstado() {
    return api.get<ClimaOrganizacionalEstadoResponse>('clima-organizacional/estado');
  },

  async obtenerCuestionario() {
    return api.get<ClimaOrganizacionalCuestionarioResponse>('clima-organizacional/cuestionario');
  },
};
